import { BoxContainer, TextField } from '@components/common';
import { useFormContext, Controller } from 'react-hook-form';
import { Button, IconNode } from '@components/base';
import Images from '@assets/images';
import { FieldValue } from '@helpers/types/coa';
import css from './index.module.scss';

interface FieldHeaderStates {
  data: FieldValue[];
  remove: (index?: number | number[]) => void;
  handleAddField: () => void;
}

const FieldHeader = (props: FieldHeaderStates) => {
  const { data, remove, handleAddField } = props;
  return (
    <BoxContainer title="Add Fields for Order Details" className={css.mainWrapper}>
      <div className={css.boxWrapper}>
        <div className={css.fieldDataWrapper}>
          {data.map((item: any, index: number) => (
            <FieldDataItem
              onDeleteClick={() => remove(index)}
              key={item.id}
              fieldNameIndex={`order_details.${index}.field_name`}
              showDelete={data.length > 1}
              fieldName={item.field_name}
            />
          ))}
          <Button
            variant="text"
            onClick={handleAddField}
            startIcon={<IconNode src={Images.plusRed} alt="add icon" />}>
            Add Field
          </Button>
        </div>
      </div>
    </BoxContainer>
  );
};

interface FieldDataItemStates {
  onDeleteClick: () => void;
  fieldNameIndex: string;
  showDelete: boolean;
  fieldName: string;
}

const FieldDataItem = (props: FieldDataItemStates) => {
  const { onDeleteClick, fieldNameIndex, showDelete, fieldName } = props;
  const { control } = useFormContext<any>();
  return (
    <>
      <div className={css.fieldDataItem}>
        <Controller
          name={fieldNameIndex}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              required
              type="text"
              inputMode="text"
              enterKeyHint="next"
              placeholder="Enter Field Name"
              disabled={fieldName === 'Item' || fieldName === 'Batch Number'}
              error={fieldState.invalid}
              endIcon={fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />}
              helperText={fieldState.error?.message}
            />
          )}
        />
        {showDelete && fieldName != 'Item' && fieldName != 'Batch Number' ? (
          <Button
            variant="text"
            title="Delete Item"
            onClick={onDeleteClick}
            startIcon={<IconNode src={Images.deleteRed} alt="delete icon" />}></Button>
        ) : (
          <Button
            variant="text"
            title="Delete Item"
            disabled
            startIcon={<IconNode src={Images.delete} alt="delete icon" />}></Button>
        )}
      </div>
    </>
  );
};

export default FieldHeader;
